import ApiService from '../apiservice'

export default class AgravoApensoService extends ApiService {
  constructor() {
    super('/agravoApenso')
  }

  listar(processo) {
    return this.get(`/${processo}`);
  }

  consultarPorNumero(numero, empresa) {
    return this.get(`/numero?numero=${numero}&empresa=${empresa}`);
  }

  consultarProcessoExistente(codigo) {
    return this.get(`/processoExistente/${codigo}`);
  }

  excluirRegistro(codigo) {
    return this.delete(`/${codigo}`);
  }

  cadastrarAgravoApenso(objeto) {
    return this.post('/',objeto);
  }

  consultaAgravoApenso(processo) {
    return this.get(`/porProcesso/${processo}`);
  }

  alterar(agravoApenso) {
    return this.put('/',agravoApenso);
  }
}